import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";

// eslint-disable-next-line @nx/enforce-module-boundaries
import { UserStateModule } from "@hermes/hermes-web-states-user-state";

import { EmptyComponentComponent } from "./components/empty-component/empty-component.component";
import { ErrorPageComponent } from "./components/error-page/error-page.component";
import { MainContentComponent } from "./components/main-content/main-content.component";
import { NotFoundPageComponent } from "./components/not-found-page/not-found-page.component";
import { LocalePrefixGuard } from "./guards/locale-prefix.guard";
import { CustomerSessionResolver } from "./resolvers/customer-session.resolver";
import { XsrfTokenResolver } from "./resolvers/xsrf-token.resolver";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        UserStateModule,
        EmptyComponentComponent,
        ErrorPageComponent,
        MainContentComponent,
        NotFoundPageComponent,
    ],
    providers: [CustomerSessionResolver, LocalePrefixGuard, XsrfTokenResolver],
    exports: [
        EmptyComponentComponent,
        ErrorPageComponent,
        MainContentComponent,
    ],
})
export class RouterComponentsModule {}
